import { render } from "./ItemAddlistPro.vue?vue&type=template&id=7687e17b"
import script from "./ItemAddlistPro.vue?vue&type=script&lang=js"
export * from "./ItemAddlistPro.vue?vue&type=script&lang=js"

import "./ItemAddlistPro.vue?vue&type=style&index=0&id=7687e17b&lang=css"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__